import {
  OrderItem,
  OrderHistoryItem,
  OrderSideEnum,
} from '@libs/api-reference';
import { DeductionsStoreType } from '@core/symbol';

function algorithmAverageTransactionPrice(
  order: OrderItem | OrderHistoryItem,
  wage: DeductionsStoreType
) {
  const { executedValue = 0, executedQuantity, orderSideId } = order || {};

  const calcWage =
    orderSideId === OrderSideEnum.Buy ? 1 + wage.buyValue : 1 - wage.sellValue;

  return executedQuantity && executedValue && calcWage
    ? executedValue / calcWage / executedQuantity
    : 0;
}

function omsAverageTransactionPrice(
  microTransactionsValue: number,
  microTransactionsQuantities: number
) {
  return microTransactionsQuantities
    ? microTransactionsValue / microTransactionsQuantities
    : 0;
}

export { algorithmAverageTransactionPrice, omsAverageTransactionPrice };
